/**
 * @desc        Account/user reducer
 * @version     1.2 - 14 Jun 24 */

import * as actionTypes from 'redux/actions/action-types.js'

const initialState = {
    me: {
        lastFetch: 0,
        loading: false,
    },
    farms: {
        lastFetch: 0,
        loading: false,
    },
    farmId: -1,
}

const account = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.STORE_INIT:
            if (action?.data?.farm) {
                return {
                    ...initialState,
                    newFarm: action.data.farm,
                }
            } else {
                return {
                    ...initialState,
                }
            }
        case actionTypes.FD_ME_REQUEST_SUCCESS: //me in that tenant
            return {
                ...state,
                me: {
                    ...state.me,
                    loading: false,
                    lastFetch: Date.now(),
                    data: action.data,
                    error: null,
                },
            }
        case actionTypes.FD_ME_REQUEST:
            return {
                ...state,
                me: {
                    ...state.me,
                    loading: true,
                },
            }
        case actionTypes.FD_ME_REQUEST_FAILURE:
            return {
                ...state,
                me: {
                    ...state.me,
                    loading: false,
                    error: action.error,
                    lastError: Date.now(),
                },
            }
        case actionTypes.FD_ME_CACHE:
            return {
                ...state,
            }
        case actionTypes.FD_US_REQUEST_SUCCESS: //userSettings in that tenant
            return {
                ...state,
                userSettings: {
                    ...state.userSettings,
                    loading: false,
                    lastFetch: Date.now(),
                    data: action.data,
                    error: null,
                },
            }
        case actionTypes.FD_US_REQUEST:
            return {
                ...state,
                userSettings: {
                    ...state.userSettings,
                    loading: true,
                },
            }
        case actionTypes.FD_US_REQUEST_FAILURE:
            return {
                ...state,
                userSettings: {
                    ...state.userSettings,
                    loading: false,
                    error: action.error,
                    lastError: Date.now(),
                },
            }
        case actionTypes.FD_FARMS_CACHE:
            return {
                ...state,
            }
        // case actionTypes.FD_FARMS_REQUEST_SUCCESS: //previous one
        // 	return {
        // 		...state,
        // 		farms: {
        // 			...state.farms,
        // 			loading: false,
        // 			lastFetch: Date.now(),
        // 			data: action.data,
        // 		},
        // 		farmId:
        // 			state.farms.data[0] === action.data[0]
        // 				? state.farmId
        // 				: action.data.items[0].id,
        // 	}
        case actionTypes.FD_FARMS_REQUEST_SUCCESS: // new experimental
            if (action.defaultFarmId) {
                return {
                    ...state,
                    farms: {
                        ...state.farms,
                        loading: false,
                        lastFetch: Date.now(),
                        data: action.data,
                    },
                    farmId: action.defaultFarmId,
                }
            } else {
                return {
                    ...state,
                    farms: {
                        ...state.farms,
                        loading: false,
                        lastFetch: Date.now(),
                        data: action.data,
                    },
                }
            }

        case actionTypes.FD_FARMS_REQUEST:
            return {
                ...state,
                farms: {
                    ...state.farms,
                    loading: true,
                },
                // farmId: -1,
            }
        case actionTypes.FD_FARMS_REQUEST_FAILURE:
            return {
                ...state,
                farms: {
                    ...state.farms,
                    loading: false,
                    error: action.error,
                    lastError: Date.now(),
                },
            }
        case actionTypes.FD_US_CACHE:
            return {
                ...state,
            }
        case actionTypes.FD_FARMID_SET: //farms
            return {
                ...state,
                farmId: action.data,
            }
        default: {
            return state
        }
    }
}

export default account
